import { Heart, Music, Flower2, Camera, GlassWater, Users } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { CtaBanner } from "@/components/CtaBanner";
import { Reveal, Overline } from "@/components/motion";
import { IMAGES } from "@/data/site";

const STEPS = [
  { time: "16:00", title: "Îmbarcarea oaspeților", desc: "Ne întâlnim în Marina Life Harbour, Limanu. Prosecco de bun venit și primele fotografii pe punte." },
  { time: "17:30", title: "Navigare spre larg", desc: "Lăsăm digul în urmă. Marea se liniștește, lumina se încălzește — ora de aur începe." },
  { time: "19:00", title: "Ceremonia la apus", desc: "Făgăduielile se spun cu orizontul în spate. Marea Neagră este martora voastră." },
  { time: "20:30", title: "Recepție pe punte", desc: "Catering, muzică și dans sub stele. Retur în port pe firul luminilor orașului." },
];

const INCLUDES = [
  { icon: Users, text: "Până la 10 oaspeți la bord" },
  { icon: Flower2, text: "Decor floral în stil marinăresc" },
  { icon: GlassWater, text: "Șampanie & catering la cerere" },
  { icon: Music, text: "Playlist personalizat sau muzician live" },
  { icon: Camera, text: "Cadre de neuitat la golden hour" },
  { icon: Heart, text: "Ofițer de ceremonie simbolic, opțional" },
];

const Nunti = () => (
  <div data-testid="nunti-page">
    <PageHero
      testid="nunti-hero"
      image={IMAGES.weddings}
      alt="Miri pe puntea unui velier, în lumina apusului"
      overline="Nunți & Evenimente Private"
      titleLines={["Ziua în care marea", "devine martoră."]}
      subtitle="O ceremonie intimă pe puntea unui velier clasic, cu Marea Neagră întinzându-se până la orizont. Pentru cei care își doresc o nuntă diferită de orice au văzut invitații vreodată."
    />

    <section className="mx-auto max-w-[1440px] px-6 py-24 lg:px-12 lg:py-32">
      <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <Overline className="mb-6">Programul Zilei</Overline>
            <h2 className="font-serif text-3xl font-light leading-tight text-ivory sm:text-4xl">
              O după-amiază care curge <span className="italic text-gold">ca valul.</span>
            </h2>
            <p className="mt-6 text-sm leading-relaxed text-mist">
              Programul este orientativ și se adaptează orei apusului și
              poveștii voastre. Fiecare nuntă este croită separat.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          {STEPS.map((step, i) => (
            <Reveal key={step.time} delay={i * 0.1}>
              <div className="flex gap-8 border-t border-white/10 py-8">
                <p className="w-16 shrink-0 font-serif text-2xl text-gold">{step.time}</p>
                <div>
                  <h3 className="font-serif text-xl text-ivory">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-mist">{step.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <section className="border-y border-white/10 bg-deep">
      <div className="mx-auto max-w-[1440px] px-6 py-24 lg:px-12 lg:py-32">
        <Reveal className="mb-16">
          <Overline className="mb-6">Ce Include</Overline>
          <h2 className="font-serif text-3xl font-light text-ivory sm:text-4xl">
            Tot ce trebuie pentru <span className="italic text-gold">„da”-ul perfect.</span>
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {INCLUDES.map((item, i) => (
            <Reveal key={item.text} delay={i * 0.06} className="bg-deep">
              <div className="flex h-full items-center gap-5 p-8">
                <item.icon className="h-5 w-5 shrink-0 text-gold" />
                <p className="text-sm text-ivory/80">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <div className="mt-16 flex flex-col items-start justify-between gap-6 border border-gold/30 p-8 sm:flex-row sm:items-center lg:p-10">
            <div>
              <p className="text-[10px] uppercase tracking-[0.3em] text-gold">Tarif orientativ</p>
              <p className="mt-3 font-serif text-3xl font-light text-ivory">
                De la 100 € <span className="text-lg text-mist">/ eveniment de o zi</span>
              </p>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-mist">
              Tariful final depinde de numărul de oaspeți, catering și decor.
              Cere o ofertă personalizată pentru data voastră din 2027.
            </p>
          </div>
        </Reveal>
      </div>
    </section>

    <CtaBanner
      title="Data voastră merită rezervată din timp."
      subtitle="Weekendurile de vară se ocupă cu luni înainte. Spuneți-ne data și visul — ne ocupăm de restul."
    />
  </div>
);

export default Nunti;
